<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Staff Access</h3>
       </template>
       <breadcrumb-menu></breadcrumb-menu>
       <!-- SEARCH BY USERNAME -->
       <div class="row">
          <div class="col-md-6">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
          <div class="col-md-4">
            <div class="form-group">
               <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Filter By Supervisor </p>
               <select v-model="filter_by_supervisor" @change="supervisorMember"class="form-control" required>
                  <option value="">-- Select Supervisor --</option>
                   <option v-for="sup in supervisor" v-bind:value="sup.id">{{sup.full_name | capitalize}} - {{sup.position_name | capitalize}}</option>
               </select>
            </div>
         </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                <select v-model="order_by" class="form-control" required>
                   <option value="">Default</option>
                   <option value="-1">ASC</option>
                   <option value="1">DESC</option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                <select v-model="page_limit" class="form-control" required>
                   <option value="">Default</option>
                   <option value="5">5</option>
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                   <option value="100">100</option>
                   <option value="500">500</option>
                </select>
             </div>
          </div>
       </div>
       <hr/>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th width="20" >#</th>
                   <th>Full Name</th>
                   <th width="500"></th>
                   <th width="200"></th>
                   <th width="200"></th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="(item,i) in computedEmployee">
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{i+1}}</td>
                      <td>{{item.full_name | capitalize}}</td>
                      <td>Belongs to <b> <i class="fa fa-long-arrow-right"></i> {{item.superior_name | capitalize}} </b></td>
                      <td></td>
                      <td><a href="#" @click="get_selected_id(item)" v-b-modal.update-user-account><u>Change Access</u></a></td>
                   </template>
                </tr>
             </tbody>
          </table>
       </div>
       <!-- MODAL FOR UPDATE RECORD  -->
       <b-modal id="update-user-account" ref="hide-user-modal"  size="l"  hide-footer @hide="doSometing">
          <h3>{{selected_item.full_name | capitalize}}</h3>
          <div class="form-group">
             <label>Account Type:</label>  
             <select class="form-control" v-model="options" @change="get_belongs">
                <option value="">-- Select One --</option>
                <option value="staff">OFFICE STAFF</option>
                <option value="admin">ADMIN STAFF</option>
                <option value="supervisor">SUPERVISOR</option>
                <option value="asm">MANAGER</option>

             </select>
          </div>
          <div class="form-group">
             <div v-if="options == 'staff'">
                <label>Belongs to:</label>      
                <select class="form-control" v-model="belongs_to" @change="get_superiorname">
                   <option value="">-- Select Supervisor --</option>
                   <option v-for="sup in supervisor" v-bind:value="sup.id">{{sup.full_name | capitalize}} - {{sup.position_name | capitalize}}</option>
                </select>
             </div>
          </div>

          <div class="form-group">
            <div v-if="options == 'supervisor'">
               <label>Belongs to:</label>      
               <select class="form-control" v-model="belongs_to" @change="get_manager_name">
                  <option value="">-- Select Manager --</option>
                  <option v-for="mag in manager" v-bind:value="mag.id">{{mag.full_name | capitalize}} - {{mag.position_name | capitalize}}</option>
               </select>
            </div>
         </div>
          <div class="form-group">
             <button class="btn btn-info float-right" @click="update_user"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
          </div>
          <br/> <br/> 
       </b-modal>
    </card>
 </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'  
    import breadcrumbMenu from './base-breadcrumb-menu'
    export default {
       components: {
           Card,
           breadcrumbMenu
       },
       data(){
            return{
                items:[],
                loading: true,
                belongs_to:'',
                selected_item:'',
                //options
                options:'',
                superior_name:'',
                supervisor:[],
                manager:[],
                 //filter
                search: '',
                order_by: '',
                sortAsc: true,
                filter_by_supervisor:'',
                 //pagination
                page_limit: '',
                start_page: 1,
                loading: true,
                //account type
                account_type:''
            }
        },
    
        mounted: function() {
          this.get_users()
          this.get_supervisor()
          this.get_belongs()
          this.get_superiorname()
          this.get_manager()
       },
    
        methods:{
            doSometing(){
                this.options = ''
            },

            supervisorMember(){
                if(this.filter_by_supervisor != ''){
                   axios.get('api/supervisor/members/'+ this.filter_by_supervisor)
                        .then(response => {  this.items = response.data;})  
                        .catch(error => {  console.log(error.response)  });
                }else{
                    this.get_users()
                }
              
            },

             get_belongs(){
                if(this.options == 'admin'){
                    this.superior_name = ({'full_name':'ADMIN'})
                    this.belongs_to = 0
                    this.account_type = 'ADMIN'
                }else if(this.options == 'supervisor'){
                    this.superior_name = ({'full_name':''})
                    this.belongs_to = 0
                    this.account_type = 'SUPERVISOR'
                }else if(this.options == 'asm'){
                    this.superior_name = ({'full_name':''})
                    this.belongs_to = 0
                    this.account_type = 'ASM'
                }else if(this.options == 'staff'){
                  
                    this.account_type = 'STAFF'
                }
             },
             
             get_superiorname(){
                if(this.options == 'supervisor'){
                        this.account_type = 'STAFF'
                        axios.get('api/superiorname/get/'+ this.belongs_to)
                        .then(response => {  
                              this.superior_name = response.data;
                              console.log('superior_name:',superior_name)
                          })  
                        .catch(error => {  console.log(error.response)  });
                    }
                },

              get_manager_name(){
                if(this.options == 'supervisor'){
                        this.account_type = 'SUPERVISOR'
                        axios.get('api/superiorname/get/'+ this.belongs_to)
                        .then(response => {  this.superior_name = response.data;})  
                        .catch(error => {  console.log(error.response)  });
                    }
                },    

             get_supervisor(){
             axios.get('api/supervisor')
                  .then(resp => { this.supervisor = resp.data; })
                  .catch(error => { console.log(error.response) });
              },

             get_manager(){
                axios.get('api/operation')
                  .then(resp => { this.manager = resp.data; })
                  .catch(error => { console.log(error.response) });
             },
            
              get_users(){
                axios.get('api/groupaccess')
                    .then(response => {   this.items = response.data; this.loading = false; })  
                    .catch(error => {  console.log(error) });
              },
    
              get_selected_id(item) {
                   this.selected_item = item;
              },
             //UPDATE USER BELONGS
              update_user(){

                console.log('response => superior :',this.superior_name.full_name)
                console.log('response => belongs_to :',this.belongs_to)
                console.log('response => account_type :',this.account_type)
                    axios.post('api/belongsto/update/' + this.selected_item.id,{
                            'account_type':this.account_type,
                            'belongs_to':this.belongs_to,
                    })
                    .then(resp => {
                        if(resp.data.response == 'success'){
                          this.get_users();
                          this.$swal('Save',resp.data.message, 'success')
                          this.$refs['hide-user-modal'].hide();
                        }else{
                          this.$swal('Error',resp.data.message,'error')
                        }   
                    })      
                    .catch(error => {console.log(error);});
              },    
       },
computed: {
// PAGINATION
offset() {
   return ((this.start_page - 1) * this.page_limit);
},

limit() {
   return ((this.offset + this.page_limit));
},

total_record() {
   return this.items.length
},

numOfPages() {
   return Math.ceil(this.items.length / this.page_limit);
},


computedEmployee() {
   let filtered = this.items
    if(filtered.length > 0){
          // SEARCH BY EMPLOYEE FULLNAME  
          if (this.search) {
              filtered = filtered.filter(
              item => item.full_name.toLowerCase().indexOf(this.search) > -1
              );
              return filtered
          }

          // SORTING NUMBER OF DISPLAY
          if (this.page_limit) {
              filtered = filtered.slice(this.offset, this.limit)
              return filtered
          }

          // ORDER BY ASC AND DESC COMBOBOX
          if (this.order_by) {
              filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
              return filtered
          }
      }
   return filtered
}
},
      
    }
    </script>
   


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/todo-group-access.vue